const EducationDetailData = {
    category: "शिक्षा",
    title: "राज्य में शिक्षा सुधार पर जोर, छात्रों के लिए नई योजनाओं की तैयारी",
    description: "सरकार शिक्षा व्यवस्था को मजबूत करने के लिए नए सुधारों और योजनाओं पर काम कर रही है, जिससे छात्रों को बेहतर सुविधाएं और गुणवत्तापूर्ण शिक्षा मिल सके।",

    image: "https://www.ecoleglobale.com/blog/wp-content/uploads/2023/01/What-are-The-Significant-Gaps-In-The-Indian-Education-System.png",
    author: {
        name: "Kaushiki",
        avatar: "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png",
        date: "05 Jan 2026 09:21 IST"
    },
    whatsappText: "ताजा खबरों से अपडेट रहने के लिए हमारे Whatsapp Channel को Join करें",

    content: [{
            heading: "शिक्षा पर विशेष ध्यान",
            paragraph: "भोपाल। राज्य सरकार द्वारा शिक्षा व्यवस्था को मजबूत करने के लिए लगातार प्रयास किए जा रहे हैं। मुख्यमंत्री के निर्देश पर स्कूलों और कॉलेजों में गुणवत्तापूर्ण शिक्षा को प्राथमिकता दी जा रही है।"
        },
        {
            heading: "छात्रों के लिए नई योजनाएं",
            paragraph: "राज्य में छात्रों के हित में कई नई शैक्षणिक योजनाओं की शुरुआत की जा रही है। इन योजनाओं का उद्देश्य आर्थिक रूप से कमजोर छात्रों को शिक्षा से जोड़ना है।"
        },
        {
            heading: "डिजिटल शिक्षा को बढ़ावा",
            paragraph: "सरकार डिजिटल शिक्षा को बढ़ावा देने के लिए स्मार्ट क्लास, ऑनलाइन पढ़ाई और ई-लर्निंग प्लेटफॉर्म पर विशेष ध्यान दे रही है।"
        },
        {
            heading: "शिक्षकों की भूमिका",
            paragraph: "शिक्षा की गुणवत्ता सुधारने के लिए शिक्षकों के प्रशिक्षण और उनकी सुविधाओं को बेहतर बनाने पर भी जोर दिया जा रहा है।"
        },
        {
            heading: "ग्रामीण शिक्षा पर फोकस",
            paragraph: "ग्रामीण क्षेत्रों में शिक्षा के स्तर को ऊपर उठाने के लिए नए स्कूल भवन, छात्रावास और छात्रवृत्ति योजनाओं पर काम किया जा रहा है।"
        },
        {
            heading: "छात्रों का सर्वांगीण विकास",
            paragraph: "पढ़ाई के साथ-साथ खेल, कौशल विकास और व्यक्तित्व निर्माण के लिए भी विभिन्न कार्यक्रम चलाए जा रहे हैं।"
        },
        {
            heading: "भविष्य की तैयारी",
            paragraph: "सरकार का लक्ष्य है कि आने वाले समय में राज्य का हर छात्र आधुनिक शिक्षा, तकनीकी ज्ञान और बेहतर अवसरों से जुड़ सके।"
        }
    ]

};

export default EducationDetailData;